<div class="customization-modal-content">
  <div class="customization-header">
    <h5 class="customization-title">Customization</h5>
    <button type="button" class="close-btn" aria-label="Close" (click)="closeModal()">
      <i class="fa-solid fa-times"></i>
    </button>
  </div>
  <div class="customization-body">
    <!-- Loading State -->
    <div *ngIf="isLoading" class="loading-state">
      <i class="fa-solid fa-spinner fa-spin"></i>
      <p>Loading customization settings...</p>
    </div>

    <!-- Homepage Color Section -->
    <div class="customization-field" *ngIf="!isLoading">
      <div class="field-header">
        <label class="field-label">Homepage Color</label>
        <button 
          type="button" 
          class="reset-btn" 
          (click)="resetHomepageColor()"
          [disabled]="isHomepageColorDefault()"
          title="Reset to default">
          <i class="fa-solid fa-rotate-left"></i> Reset to Default
        </button>
      </div>
      
      <!-- Color Type Selector -->
      <div class="color-type-selector">
        <button 
          type="button" 
          class="type-btn" 
          [class.active]="homepageColor.type === 'solid'"
          (click)="setColorType('solid')">
          <i class="fa-solid fa-fill"></i> Solid
        </button>
        <button 
          type="button" 
          class="type-btn" 
          [class.active]="homepageColor.type === 'gradient'"
          (click)="setColorType('gradient')">
          <i class="fa-solid fa-sliders"></i> Gradient
        </button>
      </div>

      <!-- Color Pickers -->
      <div class="color-pickers">
        <div class="color-picker-item" *ngFor="let color of homepageColor.colors; let i = index">
          <div class="color-picker-wrapper">
            <input 
              type="color" 
              [value]="color" 
              (input)="updateColor(i, $any($event.target).value)"
              class="color-input"
              [id]="'color-' + i">
            <label [for]="'color-' + i" class="color-label">
              <div class="color-preview" [style.background-color]="color"></div>
              <input 
                type="text" 
                [value]="color" 
                (input)="updateColor(i, $any($event.target).value)"
                class="color-text-input"
                placeholder="#000000">
            </label>
            <button 
              type="button" 
              class="remove-color-btn" 
              (click)="removeColor(i)"
              [disabled]="homepageColor.colors.length === 1"
              *ngIf="homepageColor.type === 'gradient'">
              <i class="fa-solid fa-times"></i>
            </button>
          </div>
        </div>
        
        <!-- Add Color Button (only for gradient) -->
        <button 
          type="button" 
          class="add-color-btn" 
          (click)="addColor()"
          *ngIf="homepageColor.type === 'gradient'">
          <i class="fa-solid fa-plus"></i> Add Color
        </button>
      </div>

      <!-- Preview -->
      <div class="preview-section">
        <label class="preview-label">Preview</label>
        <div class="preview-box" [style]="getPreviewStyle()">
          <span class="preview-text">Homepage Preview</span>
        </div>
      </div>
    </div>
  </div>
  <div class="customization-footer">
    <button type="button" class="btn btn-secondary" (click)="closeModal()" [disabled]="isSaving">Close</button>
    <button type="button" class="btn btn-primary" (click)="saveCustomization()" [disabled]="isSaving">
      <span *ngIf="!isSaving">Save</span>
      <span *ngIf="isSaving">
        <i class="fa-solid fa-spinner fa-spin"></i> Saving...
      </span>
    </button>
  </div>
</div>

